import * as React from "react";
import Image, {ImageObject} from "../../../image/Image";
import Video, {VideoType} from "../../../videos/video/Video";
import * as styles from "./carousel-media.module.scss";

export function CarouselMedia(slide: Queries.CarouselSlideFragmentFragment) {
  const {videoSource, videoControls, videoBehavior} = slide;

  if (videoSource) {
    return (
      <div className={styles.carouselMedia__video}>
        <Video
          videoSource={videoSource}
          type={(videoBehavior) as VideoType}
          showControl={videoControls || undefined}
        />
      </div>
    );
  }

  if (slide.image) {
    return (
      <Image
        imageClasses={styles.carouselMedia__image}
        image={slide.image as ImageObject}
      />
    );
  }

  return null;
}
